<template>
  <div class="login">
    <div class="login-all">
        <div class="caikuang-shop">弹幕红警大乱斗彩矿商城</div>
        <div class="login-btn">
            <div class="huoqu">
                <div style="margin-bottom:0.3rem"><span>请复制以下绑定码</span></div>
                <div style="margin-bottom:0.4rem">
                    <input class="huoqu-input" type="textarea" id="txt" v-model="value" />
                    <span class="huoqu-btn" @click="on_copy">一键复制</span>
                </div>
                <!-- <span class="huoqu-btn" @click="on_copy">获取绑定码</span> -->
            </div>
            <div class="login-tip">
                <p>进入b站直播间粘贴发送弹幕</p>
                <!-- <p>2、进入b站直播间进行粘贴</p>
                <p>3、返回当前页面即可登录</p> -->
            </div>
            <a href="https://live.bilibili.com/31124528" target="_blank">点击跳转B站直播间</a>
            <div class="login-tip">
                <a href="/">发送弹幕后刷新当前页</a>
            </div>

        </div>
        <van-popup v-model="show">
            <div class="show-dialog">
                <div>
                    <span>绑定码复制成功</span>
                    <span>请到直播间进行粘贴</span>
                </div>
                <a href="https://live.bilibili.com/31124528" target="_blank">点击跳转B站直播间</a>
                <a href="/">发送弹幕后刷新当前页</a>
            </div>
        </van-popup>
    </div>
    <!-- <myFoot></myFoot> -->
    <a href="https://beian.miit.gov.cn/" style="margin-top:100px;color:#fff;font-size:14px">京ICP备2023039941号-1</a>
  </div>
</template>

<script>
import Vue from 'vue'
import { Popup } from 'vant'
import { get } from './../../utils/httpService'
import myFoot from './../../components/foot.vue'
Vue.use(Popup)
export default {
  name: 'login',
  data () {
    return {
      uid: '',
      value: '',
      show: false
    }
  },
  components: {
    myFoot
  },
  created () {
    this.fetchData()
    // localStorage.setItem('utoken', 'e0565f3e-fd4c-40da-af38-39fd153affac')
  },
  methods: {
    on_login () {
      this.$router.push({
        path: '/'
        // query: {uid: 1}
      })
    },
    on_copy () {
      var element = document.getElementById('txt')
      element.select()
      element.setSelectionRange(0, element.value.length)
      document.execCommand('copy')
      navigator.clipboard.writeText(this.value).then(() => { this.show = true })
    },
    async fetchData () {
      try {
        let authInfo = await get('/login/session')
        console.log('fetchData', authInfo)
        localStorage.setItem('utoken', authInfo.token)
        console.log('authInfo.token', authInfo.token)
        if (authInfo.uid !== 0) {
          this.on_login()
        }
        if (authInfo.key !== '') {
          this.value = authInfo.key
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
  }
}
</script>

<style>
.login{width: 100%;height: 100vh;background: #000;display: flex;align-items: center;justify-content: center;flex-direction: column;}
.login-btn{color: #fff;font-size: 0.36rem;padding: 0.18rem 0.45rem;display: flex;flex-direction: column;align-items: center;justify-content: center;}
.huoqu{display: flex;flex-direction: column;align-items: center;}
.huoqu-input{color: #000;}
.huoqu-btn{border:1px solid #fff;padding: 4px 10px;border-radius: 4px;font-size: 0.3rem;margin-bottom: 0.2rem;margin-left: 0.2rem;cursor: pointer;}
.login-tip{font-size: 0.3rem;color: #ccc;margin-top: 0.3rem;margin-bottom: 0.2rem;}
.show-dialog{font-size: 0.3rem;padding: 0.5rem; display: flex;flex-direction: column;}
.show-dialog div{display: flex;flex-direction: column;align-items: center;}
.show-dialog a{text-align: center;margin-top:10px;background: #000;color: #fff;}
.login-btn a{color: rgba(238, 183, 2, 0.668);font-size: 0.3rem;text-decoration: underline;}
.caikuang-shop{color: #fff;font-size: 0.5rem;text-align: center;margin-bottom: 50px;color: rgb(249, 202, 46);}
/* .login-btn span{display: inline-block;margin-left: 0.1rem;color: rgba(238, 183, 2, 0.668)} */
/* .foot{font-size: 14px;margin-bottom: 20px;margin-top: 50px;width: 100%;display: flex;justify-content: center;}
.foot-b a{color: #fff !important; pointer-events: none;} */
</style>



// WEBPACK FOOTER //
// src/view/login/index.vue